const backgroundColor = ({color}) => {
  document.documentElement.style.setProperty('--bodyColor', color)
}

export default backgroundColor